module.exports = __webpack_public_path__ + "static/media/sku860201678.e8aa1420.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/sku860201678.png
// module id = 601
// module chunks = 0